import React from 'react';
import { Button } from 'semantic-ui-react';
import {setHasHeaderReceived} from "../../actions/headerActions";
import {connect} from "react-redux";

// import { end } from '../../lib/iot';

const SignIn = () => {
    // React.useEffect(() => {
    //   end();
    // }, []);

    // if (!location.state) {
    //   history.replace('/');
    //   return null;
    // }
    //
    const handleSignIn = () => {
        const url = 'https://doosanfuelcell.cloud/signin?next=' + window.location.origin + '/';
        window.location.assign(url);
    };

    return (
        <div style={styles.div}>
            <h1>Your session has expired</h1>
            <Button
                color='blue'
                content='Go to sign in'
                inverted
                onClick={handleSignIn}
            />
        </div>
    );
};

const styles = {
    div: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    }
};

export default SignIn;